<!-- <div class="form-group floating">            
	<ui-select ng-model="filterData.station_id" title="By Station..." class="ml10 operation-live-search" style="width:200px">
		<ui-select-match placeholder="By Station...">
			{{ $select.selected.state }} - {{ $select.selected.code }}
		</ui-select-match>
		<ui-select-choices repeat="item.id as item in (data.stations | filter: $select.search ) track by $index">
			<span ng-bind-html="item.state + ' - ' + item.code | highlight: $select.search"></span>
		</ui-select-choices>
	</ui-select>
</div> -->

<div class="form-group floating">            
	<select class="ml10 selectpicker" 
		multiple 
		title="By Type"
		data-live-search="true" 
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.workTypes"
		data-style="btn-primary">
		<option ng-repeat="item in data.types" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
	</select>
</div> 

<div class="form-group floating">
	<select class="ml10 selectpicker" 
		multiple 
		title="By Station"
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.stations"
		data-style="btn-primary"
		ng-keyup="$event.keyCode == 13 && refreshData()">
		<option ng-repeat="item in data.stations" data-select-watcher data-last="{{$last}}" value="{{item.id}}">
			{{ item.code }} - {{ item.city }}
		</option>
	</select>
</div>

<div class="form-group floating">
	<input 
		type="text" 
		ng-model="filterData.location" 
		class="btn btn-operation ml10 text-input" 
		placeholder="By Customer"
		ng-keyup="$event.keyCode == 13 && refreshData()">
</div>

<div class="form-group floating">
	<select class="ml10 selectpicker" 
		multiple 
		data-live-search="true"
		title="By Partner"
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.customers"
		data-style="btn-primary"
		ng-keyup="$event.keyCode == 13 && refreshData()">
		<option ng-repeat="item in data.customers" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.dba_name ? item.dba_name : item.customer_name}}</option>
	</select>
</div>

<div class="form-group floating">
	<select class="ml10 selectpicker" 
		multiple 
		data-live-search="true"
		title="By Driver"
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.workers"
		data-style="btn-primary"
		ng-keyup="$event.keyCode == 13 && refreshData()">
		<option ng-repeat="member in data.workers | orderBy:'full_name'" ng-if="!member.user.status" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
	</select>
</div>

<div class="form-group floating">
	<input 
		type="text" 
		ng-model="filterData.term" 
		class="btn btn-operation ml10 text-input" 
		placeholder="By Order ID"
		ng-keyup="$event.keyCode == 13 && refreshData()">
</div>

<div class="form-group floating">
	<input 
		type="text" 
		ng-model="filterData.qr" 
		class="btn btn-operation ml10 text-input" 
		placeholder="By QR Code"
		ng-keyup="$event.keyCode == 13 && refreshData()">
</div>

<div class="form-group floating">
	<input 
		type="text" 
		options="opts" 
		date-range-picker 
		ng-model="filterData.scheduled_time"
		class="btn btn-operation ml10" 
		placeholder="By Delivery Date"
		ng-keyup="$event.keyCode == 13 && refreshData()">
</div>

<div class="form-group floating">            
	<select class="ml10 selectpicker" 
		multiple 
		title="By Status"
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.workSteps"
		data-style="btn-primary"
		ng-keyup="$event.keyCode == 13 && refreshData()">
		<option 
			ng-repeat="item in data.steps | orderBy:'sort'" 
			data-select-watcher data-last="{{$last}}" 
			value="{{item.id}}" 
			class="color-{{item.value}}">
			{{item.name}}
		</option>
	</select>
</div> 

<!-- <input 
	type="text" 
	options="opts" 
	date-range-picker 
	ng-model="filterData.scheduled_time"
	class="btn btn-operation ml10" 
	placeholder="Kargo Tarihi" > -->

<!-- <div class="pull-left" ng-if="filterProp.indexOf('teams') !== -1">
	<select class="ml10 selectpicker" 
		multiple 
		title="Ekip"
		data-live-search="true" 
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.teams"
		data-style="btn-primary">
		<option ng-repeat="item in authenticatedUser.teams" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
	</select>
	<a href="#" ng-click="addFilterProps('teams')"><i class="fa fa-close"></i></a>
</div> -->

<!-- <select class="ml10 selectpicker" 
	multiple 
	title="Personel"
	data-live-search="true" 
	data-selected-text-format="count" 
	data-language="tr_TR"
	ng-model="filterData.workers"
	data-style="btn-primary">
	<option ng-repeat="member in data.workers" data-select-watcher data-last="{{$last}}" value="{{member.id}}">{{member.full_name}}</option>
</select> -->

<!-- <select class="ml10 selectpicker" 
	multiple 
	title="Route"
	data-live-search="true" 
	data-selected-text-format="count" 
	data-language="tr_TR"
	ng-model="filterData.routes"
	data-style="btn-primary">
	<option ng-repeat="route in data.routes" data-select-watcher data-last="{{$last}}" value="{{route.id}}">{{route.unique}}</option>
</select>

<div class="pull-left">
	<ui-select 
		ng-model="filterData.customers" 
		title="Müşteri Seçiniz..." 
		class="ml10 operation-live-search" 
		style="width:200px">
		<ui-select-match placeholder="Müşteri Seçiniz...">
			{{ $select.selected.customer_name }}
		</ui-select-match>
		<ui-select-choices repeat="item.id as item in (data.customers | filter: $select.search ) track by $index">
			<span ng-bind-html="item.customer_name | highlight: $select.search"></span>
		</ui-select-choices>
	</ui-select>
</div> -->

<!-- <div class="pull-left">            
	<select class="ml10 selectpicker" 
		multiple 
		title="Kargo Durumu"
		data-live-search="true" 
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.workSteps"
		data-style="btn-primary">
		<option ng-repeat="item in data.steps" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
	</select>
</div> -->

<!-- <div class="pull-left">
	<select class="ml10 selectpicker" 
		multiple 
		title="Kargo Türü"
		data-live-search="true" 
		data-selected-text-format="count" 
		data-language="tr_TR"
		ng-model="filterData.workTypes"
		data-style="btn-primary">
		<option ng-repeat="item in data.types" data-select-watcher data-last="{{$last}}" value="{{item.id}}">{{item.name}}</option>
	</select>
</div> -->

<a href="#" 
	class="btn w50 p-2 ml10" 
	ng-click="refreshData('map')"
	ng-if="filterData.stations.length > 0 ||
	filterData.location ||
	filterData.customers.length > 0 ||
	filterData.workers.length > 0 ||
	filterData.term ||
	filterData.qr ||
	filterData.scheduled_time.startDate ||
	filterData.workSteps.length > 0 ||
	filterData.workTypes.length > 0" 
	style="line-height: 20px;">
	<i class="fa fa-refresh"></i>
</a>

<a href="#" 
	ng-if="filterData.stations.length > 0 ||
	filterData.location ||
	filterData.customers.length > 0 ||
	filterData.workers.length > 0 ||
	filterData.term ||
	filterData.qr ||
	filterData.scheduled_time.startDate ||
	filterData.workSteps.length > 0 ||
	filterData.workTypes.length > 0"
	class="clear-filter ml-3" 
	ng-click="clearFilter()" style="line-height: 20px;">
	Clear Filter
</a>